<template lang="pug">
  .component-backoffice-edit-parking-group
    button.button(@click="remove") Delete
</template>

<script>
  import ModalReveal from '../../../foundation/ModalReveal'
  import BookingModeSelect from '../../../BookingModeSelect'
  import KeplerBackofficeSdk from '../../../../../lib/kepler/backoffice'
  import MaggieHelper from '../../../../../maggieHelper'

  export default {
    name: 'DeleteParkingGroup',
    components: {BookingModeSelect, ModalReveal},
    props: ['item'],
    methods: {
      remove() {

        this.$confirm('Are you sure?', 'All connected parking lots, parking slots and vehicle slots will be deleted', () => {
          KeplerBackofficeSdk.parkingGroups.select(this.item.id).remove((data) => {
            MaggieHelper.notification('deleted', 'Parking group deleted')
            location.reload()
          })
        })
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// DeleteParkingGroup.vue?c92c3c78